import React, { useEffect, useState } from 'react';
import './Login.scss';
import { RegistrationErrorHandler } from '../../components/registration/RegistrationErrorHandler';
import { LoginEmail } from './LoginEmail';
import { LoginParamsHandler } from './LoginParamsHandler';
import { ConfirmYourIdentity } from './ConfirmYourIdentity';

type Props = {
  path?: string;
};

export const Login: React.FC<Props> = () => {
  const [isVerified, setIsVerified] = useState<undefined | boolean>(undefined);
  const [email, setEmail] = useState('');

  const setUserNotVerified = (email: string) => {
    setEmail(email);
    setIsVerified(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [isVerified]);

  useEffect(() => {
    // This is a fix to adjust a white background colour for this service to body.
    document.body.style.backgroundColor = 'white';
  }, []);

  return (
    <RegistrationErrorHandler>
      <LoginParamsHandler>
        <>
          {typeof isVerified === 'undefined' && (
            <LoginEmail setUserNotVerified={(email) => setUserNotVerified(email)} />
          )}
          {typeof isVerified !== 'undefined' && !isVerified && <ConfirmYourIdentity email={email} />}
        </>
      </LoginParamsHandler>
    </RegistrationErrorHandler>
  );
};
